
      <!--  TOAST CONTAINER  -->

      <div class="toast-container" [ngClass]="toastState" [class.has-key-functions]="uiLayoutConfig?.hasKeyFunctions" [class.always-on-bottom]="position === 'on-bottom'" [@toast]="toastState" (@toast.done)="onAnimationEnd($event)">

          <!--  TOAST  -->

          <div *ngIf="toast" class="toast" [ngClass]="cssClasses.div">

              <!--  MESSAGE  -->

              <p [ngClass]="cssClasses.p">{{ toast.message }}</p>

              <!--  END MESSAGE  -->

              <!--  CLOSE BUTTON  -->

              <i class="far fa-times icon-button" [ngClass]="cssClasses.i" (click)="onRemove()"></i>

              <!--  END CLOSE BUTTON  -->

          </div>

          <!--  END TOAST  -->

      </div>

      <!--  END TOAST CONTAINER  -->
    